var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$vuetify.breakpoint.xsOnly ? 'text-center' : ''},[(_vm.title)?_c('h4',{class:`text-overline grey--text text--lighten-2 mb-0`},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('v-divider',{staticClass:"mb-1 primary"}),_c('address',{staticClass:"grey--text text--lighten-3 text-subtitle-1"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }